import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCzFlag = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 50,
	height: 50,
	viewBox: "0 0 50 50",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_1339_53163)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M0.31748 41.1709L24.9995 25L0.31748 8.8291C0.127539 8.98721 -0.000488281 9.21631 -0.000488281 9.48271V40.5172C-0.000488281 40.7837 0.127539 41.0128 0.31748 41.1709Z",
					fill: "#41479B"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M0.316406 41.1709C0.46582 41.2953 0.650879 41.3793 0.860449 41.3793H49.1363C49.6124 41.3793 49.9984 40.9933 49.9984 40.5172V25H24.9984L0.316406 41.1709Z",
					fill: "#CD343C"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M0.316406 8.829C0.46582 8.70459 0.650879 8.62061 0.860449 8.62061H49.1363C49.6124 8.62061 49.9984 9.00664 49.9984 9.48271V24.9999H24.9984L0.316406 8.829Z",
					fill: "#F3F3F3"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_1339_53163",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 50,
				height: 50,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgCzFlag);
export { ForwardRef as ReactComponent };
